enum GbBicValue {
  REVOGB21 = 'REVOGB21',
  REVOGB2L = 'REVOGB2L',
}

export default GbBicValue;
